import { gql } from '@apollo/client';

export const TopicFiltersQuery = gql`
  query TopicsQuery($first: Int = 100) {
    topics(first: $first) {
      nodes {
        name
        slug
      }
    }
  }
`;
